/** @type {import('./types').Copy} */
const FALLBACK_COPY = {
  label: 'Module',
  plans: {
    finalisedDateLabel: 'Finalised Date',
    caseOfficerLabel: 'Case Officer'
  },
  audits: {
    assign: {
      title: 'Assign Plans',
      assignedFrom: 'Plans Assigned From:',
      successToaster: 'Successfully assigned plans.'
    },
    all: {
      title: 'All Audits',
      dateOf: 'Review Date'
    },
    live: {
      dateOf: 'Review Date'
    },
    list: {
      internalId: 'C/YP ID',
      label: 'review',
      actions: {
        delete: {
          label: 'audit'
        }
      }
    },
    active: {
      strengths: {
        title: 'Strengths'
      }
    },
    moderated: {
      title: 'Moderated Plans',
      blurbPartOne: 'Below is a breakdown of audits for this plan',
      blurbPartTwo: 'Click the auditor name of an audit to nominate it for this plan. A nominated audit represents a plan in reporting.'
    }
  },
  criteria: {
    label: 'theme'
  }
}

/** @type {import('./types').ModuleCopy} */
export const TEXT_COPY = {
  AR: {
    label: 'AR',
    plans: {
      finalisedDateLabel: 'Review Date',
      caseOfficerLabel: 'SEN Case Officer'
    },
    audits: {
      assign: {
        title: 'Assign Plans',
        assignedFrom: 'Plans Assigned From:',
        successToaster: 'Successfully assigned plans.'
      },
      all: {
        title: 'Plans List',
        dateOf: 'Review Date'
      },
      live: {
        dateOf: 'Review Date'
      },
      list: {
        internalId: 'C/YP ID',
        label: 'review',
        actions: {
          delete: {
            label: 'plan'
          }
        }
      },
      active: {
        strengths: {
          title: 'Strengths of AR'
        }
      },
      moderated: {
        title: 'Moderated Plans',
        blurbPartOne: 'Below is a breakdown of audits for this plan',
        blurbPartTwo: 'Click the auditor name of an audit to nominate it for this plan. A nominated audit represents a plan in reporting.'
      }
    },
    criteria: {
      label: 'theme'
    }
  },
  QEPA: {
    label: 'QEPA',
    plans: {
      finalisedDateLabel: 'EP Advice Date',
      caseOfficerLabel: 'EP Report'
    },
    audits: {
      assign: {
        title: 'Assign Advice',
        assignedFrom: 'Advice Assigned From:',
        successToaster: 'Successfully assigned advice.'
      },
      all: {
        title: 'Advice List',
        dateOf: 'EP Advice Date'
      },
      live: {
        dateOf: 'EP Advice Date'
      },
      list: {
        internalId: 'C/YP ID',
        label: 'review',
        actions: {
          delete: {
            label: 'advice'
          }
        }
      },
      active: {
        strengths: {
          title: 'Strengths of EP Advice'
        }
      },
      moderated: {
        title: 'Moderated Advice',
        blurbPartOne: 'Below is a breakdown of audits for this plan',
        blurbPartTwo: 'Click the auditor name of an audit to nominate it for this advice. A nominated audit represents advice in reporting.'
      }
    },
    criteria: {
      label: 'theme'
    }
  },
  EHCP: {
    label: 'EHCP',
    plans: {
      finalisedDateLabel: 'Finalised Date',
      caseOfficerLabel: 'SEN Case Officer'
    },
    audits: {
      assign: {
        title: 'Assign Plans',
        assignedFrom: 'Plans Assigned From:',
        successToaster: 'Successfully assigned plans.'
      },
      all: {
        title: 'Plans list',
        dateOf: 'Finalised Date'
      },
      live: {
        dateOf: 'EHCP Date'
      },
      list: {
        internalId: 'Internal ID',
        label: 'audit',
        actions: {
          delete: {
            label: 'plan'
          }
        }
      },
      active: {
        strengths: {
          title: 'Strengths of EHCP'
        }
      },
      moderated: {
        title: 'Moderated Plans',
        blurbPartOne: 'Below is a breakdown of audits for this plan',
        blurbPartTwo: 'Click the auditor name of an audit to nominate it for this plan. A nominated audit represents a plan in reporting.'
      }
    },
    criteria: {
      label: 'section'
    }
  },
  PEP: {
    label: 'PEP',
    plans: {
      finalisedDateLabel: 'Finalised Date',
      caseOfficerLabel: 'Case Officer'
    },
    audits: {
      assign: {
        title: 'Assign Plans',
        assignedFrom: 'Plans Assigned From:',
        successToaster: 'Successfully assigned plans.'
      },
      all: {
        title: 'All Audits',
        dateOf: 'Review Date'
      },
      live: {
        dateOf: 'Review Date'
      },
      list: {
        internalId: 'C/YP ID',
        label: 'review',
        actions: {
          delete: {
            label: 'plan'
          }
        }
      },
      active: {
        strengths: {
          title: 'Strengths of PEP'
        }
      },
      moderated: {
        title: 'Moderated Audits',
        blurbPartOne: 'Below is a breakdown of audits for this plan',
        blurbPartTwo: 'Click the auditor name of an audit to nominate it for this plan. A nominated audit represents a plan in reporting.'
      }
    },
    criteria: {
      label: 'theme'
    }
  }
}

/**
 * @param {import('./types').Modules} [name]
 * @returns {import('./types').Copy}
 */
export const moduleCopy = (name) => {
  if (!name) return FALLBACK_COPY
  const copy = TEXT_COPY[name]
  if (!copy) return FALLBACK_COPY
  return copy
}
